namespace GeniuzPOS.Purchase {
    export enum sendapp {
        nonsend = 0,
        send = 1
    }
    Serenity.Decorators.registerEnumType(sendapp, 'GeniuzPOS.Purchase.sendapp');
}
